import React, { useState } from "react";
import MainCalculatorsList from "../OtherCalculator/CountriesMainCalculatorsList/SAMainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الضمان المطور";
const DESCRIPTION =
  "احسب قيمة الضمان الاجتماعي المطور بناءً على عدد التابعين لديك بسهولة باستخدام حاسبة الضمان الاجتماعي المطور. احصل على تقدير دقيق للمبلغ المستحق وفقًا لعدد الأفراد التابعين في أسرتك واستفد من الدعم المالي المقدم لتحسين الوضع الاجتماعي والاقتصادي.";
const KEYWORDS =
  "الضمان الاجتماعي, حاسبة الضمان المطور, دعم مالي, حساب الضمان الاجتماعي, التابعين, المساعدات الحكومية, الدعم الاجتماعي, المملكة العربية السعودية, برامج الدعم, الحساب المالي";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/advanced-social-security/";
function AdvancedSocialSecurityCalculator() {
  const [dependents, setDependents] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const calculateAmount = () => {
    const numDependents = parseInt(dependents, 10) || 0;
    let amount = 1000;
    if (numDependents > 0) {
      amount += numDependents * 285;
    }
    setResult(amount);
  };
  const handleCalculateClick = () => {
    if (!dependents) {
      setError("الرجاء إدخال عدد التابعين بشكل صحيح");
      setResult(null);
      return;
    }
    setError("");
    setTimeout(() => {
      calculateAmount();
    }, 3000);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب الضمان المطور</h2>
                <p>
                  استخدم حاسبة الضمان الاجتماعي المطور لتحديد قيمة الدعم المالي
                  المستحق بسهولة بناءً على عدد الأفراد التابعين في أسرتك. احصل
                  على تقديرات دقيقة وسريعة للمبالغ المستحقة واستفد من الدعم
                  الاجتماعي لتحسين ظروفك المعيشية والاقتصادية.{" "}
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-8 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          عدد التابعين (بدون رب الاسرة)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="0"
                        value={dependents}
                        onChange={(e) => setDependents(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculateClick}
                    >
                      احسب                    </button>
                    <br />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div>
                  {error && (
                    <p className="p-3 mb-2 bg-warning text-white">
                      خطأ: {error}
                    </p>
                  )}
                  {result !== null &&  (
                    <>
                      <p className="p-3 mb-2 bg-success text-white">
                        قيمة الضمان الاجتماعي: {result} ريال
                      </p>
                      <p className="alert alert-warning ">
                        إذا كان ( نصف دخلك أو نصف راتبك ) يفوق المبلغ الذي ظهر
                        أعلاه .. فإنك غير مستحق للضمان الإجتماعي
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <br/>      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">حاسبة الضمان الاجتماعي المطور</div>
              <div className="info-section-body">
                <h4>معلومات حول حساب الضمان الاجتماعي</h4>
                <hr />
                <h5>خطوات حساب الضمان الاجتماعي المطور</h5>
                <ol>
                  <li>قم بتحديد عدد الأفراد التابعين لك.</li>
                  <li>راجع الجدول أدناه لتحديد القيمة الأساسية المستحقة.</li>
                  <li>
                    إذا كان لديك أكثر من 6 تابعين، أضف المبلغ المخصص لكل تابع
                    إضافي إلى القيمة الأساسية.
                  </li>
                  <li>اجمع المبالغ للحصول على القيمة الإجمالية المستحقة لك.</li>
                </ol>
                <hr />
                <h5>الضمان الاجتماعي المطور</h5>
                <p>
                  هذا البرنامج هو مبادرة تم إطلاقها لتحقيق أهداف الحماية
                  الاجتماعية ودعم الفئات الأكثر احتياجًا، وذلك من خلال تقديم دعم
                  مادي، وتأهيل، وتدريب، وتوفير فرص عمل مناسبة. البرنامج يستهدف
                  فقط من يستحق الدعم وفقًا للشروط المحددة، بغض النظر عن جنسهم أو
                  وضعهم الاجتماعي.
                </p>
                <hr />
                <h5>حاسبة الضمان الاجتماعي المطور للمتقاعدين</h5>
                <p>
                  يمكن للمتقاعدين معرفة دخلهم التقاعدي باستخدام الحاسبة، وذلك
                  بإدخال مجموع الدخل الشهري للأسرة، بما في ذلك الدعم الحكومي
                  وغير الحكومي، والدخل التقاعدي للتابعين، ثم الضغط على زر
                  "احسب".
                </p>
                <h5>جدول حاسبة الضمان الاجتماعي المطور</h5>
                <table >
                  <thead>
                    <tr>
                      <th >عدد الأشخاص</th>
                      <th >
                        المبلغ المستحق (ريال سعودي)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>عائلة مكونة من شخص واحد</td>
                      <td>1000</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من شخصين</td>
                      <td>1285</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من 3 أشخاص</td>
                      <td>1570</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من 4 أشخاص</td>
                      <td>1855</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من 5 أشخاص</td>
                      <td>2140</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من 6 أشخاص</td>
                      <td>2420</td>
                    </tr>
                    <tr>
                      <td>عائلة مكونة من 7 أشخاص</td>
                      <td>2710</td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <h5>الاستعلام عن الضمان الاجتماعي باستخدام رقم الهوية</h5>
                <p>
                  للتحقق من حالة الضمان الاجتماعي باستخدام رقم الهوية، اتبع
                  الخطوات التالية:
                </p>
                <ol>
                  <li>ادخل إلى خدمة الاستعلام عن الضمان الاجتماعي "من هنا".</li>
                  <li>اطلع على تفاصيل الخدمة.</li>
                  <li>اضغط على بدء الخدمة.</li>
                  <li>أدخل رقم الهوية في حقل رقم السجل المدني.</li>
                  <li>أدخل رقم الضمان الاجتماعي.</li>
                  <li>أدخل رمز التحقق.</li>
                  <li>اضغط على أيقونة العرض.</li>
                  <li>ستظهر تفاصيل الضمان الخاصة بك.</li>
                </ol>
                <hr />
                <h5>الاستعلام عن حالة الضمان الاجتماعي برقم السجل المدني</h5>
                <p>
                  يمكنك الاستعلام عن حالة الضمان الاجتماعي عبر رقم السجل المدني
                  باتباع الخطوات التالية:
                </p>
                <ol>
                  <li>
                    ادخل إلى نظام الاستعلام الخاص بالضمان الاجتماعي "من هنا".
                  </li>
                  <li>أدخل البيانات المطلوبة وهي:</li>
                  <ol>
                    <li>رقم السجل المدني.</li>
                    <li>رقم الضمان الاجتماعي الخاص بك.</li>
                    <li>رمز التحقق المرئي.</li>
                  </ol>
                  <li>اضغط على "عرض".</li>
                  <li>
                    ستظهر كافة البيانات الخاصة بك كمستفيد من الضمان الاجتماعي.
                  </li>
                </ol>
                <hr />
                <h5>شروط الاستفادة من الضمان الاجتماعي المطور</h5>
                <p>
                  حددت وزارة الموارد البشرية في المملكة العربية السعودية شروط
                  الاستفادة من برنامج الضمان الاجتماعي المطور كما يلي:
                </p>
                <ul>
                  <li>
                    أن يكون المتقدم سعودي الجنسية، باستثناء المرأة السعودية
                    المطلقة أو الأرملة من زوج أجنبي ولديها أطفال لا معيل لهم.
                  </li>
                  <li>تقديم جميع الأوراق والمستندات المطلوبة.</li>
                  <li>عدم امتلاك المتقدم لأي عقارات أو أراضٍ مسجلة باسمه.</li>
                  <li>ألا يتجاوز راتب المتقدم الحد الأقصى لشروط الاستحقاق.</li>
                  <li>أن يكون المتقدم مقيماً في المملكة العربية السعودية.</li>
                </ul>
                <hr />
                <h5>رابط التسجيل في الضمان الاجتماعي المطور</h5>
                <p>
                  يمكن التسجيل في الضمان الاجتماعي المطور عن طريق الدخول إلى{" "}
                  <a href="https://sbis.hrsd.gov.sa/">hrsd.gov.sa</a> واتباع
                  التعليمات المحددة للتسجيل للحصول على الدعم المقدم للفئات
                  المحتاجة في المملكة العربية السعودية.
                </p>
                <h5>أسئلة شائعة</h5>
                <ul>
                  <li>
                    <strong>ما هو الضمان الاجتماعي المطور؟</strong>
                    <p>
                      هو نظام دعم مالي موجه للأفراد والعائلات بناءً على عدد
                      التابعين والمستفيدين.
                    </p>
                  </li>
                  <li>
                    <strong>كيف يتم تعديل قيم الضمان الاجتماعي؟</strong>
                    <p>
                      يتم تعديل القيم بناءً على تحديثات الحكومة واللوائح الجديدة
                      المتعلقة بالدعم المالي.
                    </p>
                  </li>
                  <li>
                    <strong>
                      هل يمكنني تقديم طلب للضمان الاجتماعي عبر الإنترنت؟
                    </strong>
                    <p>
                      نعم، يمكنك تقديم طلب عبر الموقع الإلكتروني للضمان
                      الاجتماعي أو من خلال المكاتب المعنية.
                    </p>
                  </li>
                </ul>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AdvancedSocialSecurityCalculator;
